/** Device styles are CSS modules, so class composition needs no utility framework. */
export function cn(...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(" ")
}
